import { Box, Typography } from "@mui/material";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { createSession, getActiveSession } from "../../../../../../config/Services";
import { setInLocalStorage } from "../../../../../../utils/localStorageHelpers";
import StyledButton from "../../../all-products/components/custom/StyledButton";
import {
  addLicense,
  addadvance,
  addmanagerpin,
  addmanageruidx,
  addpin,
} from "../../../all-products/redux/Actions/SessionActions";
import { getMobilePos } from "../../../all-products/redux/Reducers/paginationReducer";
import { getAmount, getLicense } from "../../../all-products/redux/Reducers/sessionReducer";
import { useSnackbar } from "../../../hooks/SnackbarProvider";
import { SessionPage } from "../../sessionPage";
import "./index.css";
import useGetDevice from "../../../hooks/useGetDevice";

export const Opening = () => {
  const showSnackbar = useSnackbar();
  const navigate = useNavigate();
  const [asManager, setAsManager] = useState(false);
  const [amountValue, setAmountvalue] = useState("");
  const retailUserDetails = JSON.parse(localStorage.getItem("retailUserDetails"));
  const roles = retailUserDetails.roles;
  const uidx = retailUserDetails?.uidx;
  const isPosManager = roles.includes("POS_MANAGER");
  const dispatch = useDispatch();
  const amount = useSelector(getAmount);
  const orgId = localStorage.getItem("orgId");
  const contextId = localStorage.getItem("locId");
  const [loader, setLoader] = useState(false);
  const [isManager, setIsManager] = useState(false);
  const selectedLicense = useSelector(getLicense);
  const daySessionId = localStorage.getItem("daySessionId");
  const isMobilePos = useSelector(getMobilePos);
  const userName = retailUserDetails?.firstName + " " + retailUserDetails?.secondName;
  const isMobile = useGetDevice();

  const handlePin = () => {
    if (isManager) {
      sessionCreationManager();
    } else {
      navigate("/session-page/authentication");
    }
  };

  const handleManagerLogin = (e) => {
    if (isPosManager) {
      setAsManager(e.target.checked);
      if (e.target.checked) {
        setIsManager(true);
      } else {
        setIsManager(false);
      }
    } else {
      showSnackbar("You are not a store manager!", "error");
      setIsManager(false);
    }
  };

  const handlevalueChange = (e) => {
    let advancePaid = e.target.value;
    dispatch(addadvance(advancePaid));
    setAmountvalue(advancePaid);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    handlePin();
  };

  const sessionCreationManager = () => {
    setLoader(true);
    let payload = {
      uidx: uidx,
      role: "CASHIER",
      organizationId: orgId,
      locationId: contextId,
      licenseName: selectedLicense?.licenseName,
      licenseId: selectedLicense?.licenseId,
      cashDrawerStartingAmount: amount === "" ? "0" : amount,
      createdBy: "manager",
      createdByName: userName,
      posType: isMobile ? "MPOS" : "POS",
    };
    createSession(payload)
      .then((res) => {
        if (res?.data?.es === 1) {
          showSnackbar(res?.data?.message + ".Please retry again", "error");
          setLoader(false);
          dispatch(
            addLicense({
              licenseId: "",
              licenseName: "",
            })
          );
          dispatch(addadvance(""));
          dispatch(addpin(""));
          dispatch(addmanagerpin(""));
          dispatch(addmanageruidx(""));
        } else {
          showSnackbar(res?.data?.message, "success");
          setLoader(false);
          getActiveSession(uidx, contextId, daySessionId).then((res) => {
            if (res?.data?.statusCode === 300) {
            } else {
              if (res?.data?.hasOwnProperty("machines")) {
                localStorage.setItem("machineId", res?.data?.machines?.[0].machineId || 0);
                if (
                  localStorage.getItem("loggedInCount") === null ||
                  localStorage.getItem("loggedInCount") === undefined
                ) {
                  localStorage.setItem("storeMode", "ONLINE");
                  localStorage.setItem("cartStoreMode", "ONLINE");
                  localStorage.setItem("loggedInCount", 1);
                }
              }
              localStorage.setItem("sessionId", res?.data?.userSession?.sessionId);
              localStorage.setItem("licenseId", res?.data?.userSession?.licenseId);
              setInLocalStorage("licenseName", res?.data?.userSession?.licenseName);
              isMobilePos &&
                emit({
                  type: "localData",
                  data: {
                    sessionId: res?.data?.userSession?.sessionId,
                    licenseId: res?.data?.userSession?.licenseId,
                    licenseName: res?.data?.userSession?.licenseName,
                  },
                });
            }
          });
          navigate("/session-page/session-listing");
        }
      })
      .catch((err) => {
        showSnackbar(err?.response?.data?.message || err?.message, "error");
        setLoader(false);
      });
  };

  return (
    <>
      <SessionPage>
        <Box sx={{ width: "60%" }}>
          <form onSubmit={handleSubmit}>
            <Box mb={2} className="opening-amount-box">
              <Typography variant="h5" fontSize="15px" fontWeight="bold" lineHeight={1.5}>
                Enter Opening Cash Amount
              </Typography>
              <input
                className="opening-amount-input"
                type="number"
                placeholder="Enter the amount"
                required
                onChange={(e) => handlevalueChange(e)}
                autoFocus
              />
            </Box>
            <Box mb={2} className="login-as-manager">
              <label htmlFor="manager-login">
                <input
                  type="checkbox"
                  id="manager-login"
                  value={asManager}
                  onChange={(e) => handleManagerLogin(e)}
                />
                <Typography
                  variant="h5"
                  fontSize="15px"
                  fontWeight="bold"
                  sx={{ display: "inline" }}
                >
                  Login as manager
                </Typography>
              </label>
            </Box>
            <StyledButton
              type="submit"
              disabled={!amount}
              size="medium"
              className="opening-amount-button"
              loading={loader}
            >
              {isManager ? "Create Session" : "Next"}
            </StyledButton>
          </form>
        </Box>
      </SessionPage>
    </>
  );
};
